export default __webpack_public_path__ + "static/media/airtable-logo.07447c27.svg";